(function () {
  if (window.location.search.indexOf('preview_theme_id=') !== -1 || window.location.search.indexOf('_cd=') !== -1) {
    document.documentElement.classList.add('is-shopify-preview');
  }

  var header = document.querySelector('[data-site-header]');
  var mobileButton = document.querySelector('[data-mobile-menu-button]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var quoteModal = document.querySelector('[data-quote-modal]');

  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 36);
  }

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  if (mobileButton && mobileMenu) {
    mobileButton.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      mobileButton.setAttribute('aria-expanded', String(open));
    });
  }

  function openQuote(button) {
    if (!quoteModal) return;
    var productTitle = button ? button.getAttribute('data-product-title') : '';
    var productUrl = button ? button.getAttribute('data-product-url') : '';
    var label = quoteModal.querySelector('[data-quote-product-label]');
    var productField = quoteModal.querySelector('[data-quote-product-field]');
    var urlField = quoteModal.querySelector('[data-quote-url-field]');

    if (label) {
      label.textContent = productTitle ? 'Target product: ' + productTitle : '';
    }

    if (productField) productField.value = productTitle || '';
    if (urlField) productUrl ? urlField.value = window.location.origin + productUrl : urlField.value = window.location.href;

    quoteModal.hidden = false;
    document.body.classList.add('quote-open');

    var firstInput = quoteModal.querySelector('input:not([type="hidden"]), select, textarea, button');
    if (firstInput) firstInput.focus();
  }

  function closeQuote() {
    if (!quoteModal) return;
    quoteModal.hidden = true;
    document.body.classList.remove('quote-open');
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-quote-open]');
    if (openButton) {
      event.preventDefault();
      openQuote(openButton);
      return;
    }

    if (event.target.closest('[data-quote-close]')) {
      event.preventDefault();
      closeQuote();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQuote();
  });

  if (window.location.hash === '#quote') {
    openQuote(null);
  }

  document.querySelectorAll('[data-featured-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-featured-tab-button]');
    var panels = tabs.querySelectorAll('[data-featured-panel]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-featured-tab-button');
        buttons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-featured-panel') === target);
        });
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === index);
        });
      });
    });
  });

  document.querySelectorAll('[data-product-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-tab-button]');
    var panels = tabs.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-tab-button');
        buttons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });
  });

  document.querySelectorAll('[data-collection-search]').forEach(function (input) {
    var cards = document.querySelectorAll('[data-product-card]');
    input.addEventListener('input', function () {
      var value = input.value.trim().toLowerCase();
      cards.forEach(function (card) {
        var text = card.textContent.toLowerCase();
        card.hidden = value && text.indexOf(value) === -1;
      });
    });
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    document.querySelectorAll('.reveal').forEach(function (element) {
      observer.observe(element);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (element) {
      element.classList.add('is-visible');
    });
  }
})();
